module.exports = __webpack_public_path__ + "img/partner1.3e1f930f.png";